import { useState, useEffect } from "react"
import moment from "moment"
import { useFormik } from "formik"
import * as Yup from "yup"
import { useReservationsContext } from "providers/ReservationsProvider/ReservationsProvider"
import { useUI } from "providers/UIProvider"
import { useAppContext } from "providers/AppProvider/AppProvider"
import { IRoles } from "types/shared"

const carNumberRegex = /^[a-zA-Z0-9]+$/
const phoneRegExp = /^5[0-9]{8}$/

interface ISchedule {
  time: string
  isActive: boolean
}

const useReservations = () => {
  const WEB_RESERVATIONS_SCHEMA = (t: any, isDiscount: boolean) =>
    Yup.object({
      carNumber: Yup.string()
        .required(t("bookings.vehicle_number_required"))
        .matches(carNumberRegex, t("bookings.vehicle_number_wrong")),
      // mobileNumber: Yup.string()
        // .required(t("bookings.phone_number_required"))
        // .matches(phoneRegExp, t("auth.form.validations.phone")),
      washPrice: Yup.string().required(t("bookings.wash.price_required")),
      discountPercent: isDiscount
        ? Yup.string().required(t("bookings.discount.percent_required"))
        : Yup.string(),
    })

  const { T, toggleModal, modals } = useUI()
  const { laundry, userRole } = useAppContext()
  const {
    selectedBranchForReservation,
    updateSelectedBranchForReservation,
    createWebReservation,
    carWashScheduleData,
  } = useReservationsContext()

  const isQappUser =
    userRole && [IRoles.QAPP_ADMIN, IRoles.QAPP_MANAGER].includes(userRole)
  //WebReservationsModal
  const [isDiscount, setIsDiscount] = useState(false)
  const [selectedBodyType, setSelectedBodyType] = useState<number>(0)
  const [selectedService, setSelectedService] = useState<number>(1)
  const [selectedDiscountTypeId, setSelectedDiscountTypeId] = useState<number>()

  

  const handleBodyType = (e: { label: string; value: number }) => {
    setSelectedBodyType(e.value)
  }

  const handleService = (e: any) => {
    setSelectedService(e.value)
  }

  const handleDiscountType = (e: any) => {
    setSelectedDiscountTypeId(e.value)
  }

  //WebReservationTimesModal
  const [selectedDay, setSelectedDay] = useState<null | string>(null)
  const [selectedSchedule, setSelectedSchedule] = useState<ISchedule[]>([])
  const [selectedHour, setSelectedHour] = useState<string | null>(null)
  const [selectedBox, setSelectedBox] = useState<number>(0)
  const [selectedWasher, setSelectedWasher] = useState<number>(0)

  const currentDate = new Date(selectedHour!)
  const transformedDate = currentDate.toISOString().slice(0, -5) + "Z"

  const selectWashDay = (item: any) => {
    setSelectedDay(item.date)
    setSelectedSchedule(item.intervals)
    setSelectedHour(null)
  }

  const selectWashHour = (item: any) => {
    const timeFormat = moment(item.time).format()
    setSelectedHour(timeFormat)
  }
  useEffect(() => {
    setSelectedDay(carWashScheduleData?.data[0]?.date)
    setSelectedSchedule(carWashScheduleData?.data[0]?.intervals)
    setSelectedHour(
      moment(carWashScheduleData?.data[0]?.intervals[0]?.time).format(),
    )
  }, [selectedBranchForReservation, carWashScheduleData])

  useEffect(() => {
    if (isQappUser) {
      updateSelectedBranchForReservation(0)
    }
  }, [modals.webReservationsTimesModal])

  useEffect(() => {
    resetForm()
    setIsDiscount(false)
    setSelectedBodyType(0)
    setSelectedService(1)
    setSelectedWasher(0)
    setSelectedBox(0)
    if (!isQappUser) {
      setSelectedDay(carWashScheduleData?.data[0]?.date)
      setSelectedSchedule(carWashScheduleData?.data[0]?.intervals)
      setSelectedHour(
        moment(carWashScheduleData?.data[0]?.intervals[0]?.time).format(),
      )
    }
  }, [modals.webReservationsModal])

  

  useEffect(() => {
    if (isDiscount === false) {
      setFieldTouched("discountPercent", false)
      setFieldValue("discountPercent", "")
      setSelectedDiscountTypeId(undefined)
    }
  }, [isDiscount])

  const onSubmit = () => {
    createWebReservation({
      vehicleBodyTypeId: selectedBodyType !== 0 ? selectedBodyType : 1,
      govNumber: values.carNumber.toUpperCase(),
      washTypeId: selectedService,
      customerMobile: values.mobileNumber.toString(),
      carWashId: isQappUser ? selectedBranchForReservation : laundry!.id,
      washTime: transformedDate,
      price: values.washPrice,
      discountTypeId: selectedDiscountTypeId ? selectedDiscountTypeId : 0,
      discount: isDiscount ? isDiscount : false,
      discountPercent: isDiscount ? Number(values.discountPercent) : 0,
      box: selectedBox ?? 0,
      employeeId: selectedWasher ?? 0,
    })
    toggleModal("webReservationsTimesModal", false)
  }
  const {
    values,
    errors,
    touched,
    handleSubmit,
    handleBlur,
    handleChange,
    resetForm,
    setFieldTouched,
    setValues,
    setFieldValue,
  } = useFormik({
    initialValues: {
      carNumber: "",
      mobileNumber: "",
      washPrice: "",
      discountPercent: "",
    },
    validationSchema: () => WEB_RESERVATIONS_SCHEMA(T, isDiscount),
    onSubmit,
  })



  return {
    form: {
      values,
      errors,
      touched,
      handleSubmit,
      handleBlur,
      handleChange,
    },
    isDiscount,
    setIsDiscount,
    selectedBodyType,
    selectedService,
    selectedDiscountTypeId,
    handleBodyType,
    handleService,
    selectedBox,
    selectedWasher,
    handleDiscountType,
    selectedDay,
    selectedSchedule,
    selectedHour,
    setSelectedBox,
    setSelectedWasher,
    selectWashDay,
    selectWashHour,
    setValues,
    setFieldValue
  }
}

export default useReservations
